import React, { useEffect, useRef } from 'react';
import anime from 'animejs';
import animationManager from './utils/AnimationManager';

const Banner = () => {
  const bannerRef = useRef(null);

  useEffect(() => {
    if (!bannerRef.current || !animationManager.shouldAnimate()) return;

    // Stagger animation for ASCII art reveal
    const lines = bannerRef.current.querySelectorAll('.banner-line');
    
    anime({
      targets: lines,
      opacity: [0, 1],
      translateX: [-50, 0],
      delay: anime.stagger(100),
      duration: 500,
      easing: 'easeOutCubic'
    });

    // Glowing effect
    anime({
      targets: bannerRef.current,
      textShadow: [
        '0 0 5px rgba(0, 255, 65, 0.5)',
        '0 0 15px rgba(0, 255, 65, 0.8)',
        '0 0 5px rgba(0, 255, 65, 0.5)'
      ],
      duration: 2000,
      loop: true,
      easing: 'easeInOutQuad'
    });
  }, []);

  const asciiLines = [
    '    ██████╗ ███████╗███████╗███████╗███████╗███████╗ ██████╗',
    '    ██╔══██╗██╔════╝██╔════╝╚══███╔╝██╔════╝██╔════╝██╔════╝',
    '    ██║  ██║█████╗  █████╗    ███╔╝ ███████╗█████╗  ██║     ',
    '    ██║  ██║██╔══╝  ██╔══╝   ███╔╝  ╚════██║██╔══╝  ██║     ',
    '    ██████╔╝███████╗███████╗███████╗███████║███████╗╚██████╗',
    '    ╚═════╝ ╚══════╝╚══════╝╚══════╝╚══════╝╚══════╝ ╚═════╝',
    '                  [ CYBERSECURITY SPECIALIST ]'
  ];

  return (
    <pre 
      ref={bannerRef}
      className="text-[#00ff41] text-[8px] sm:text-[10px] md:text-xs mb-2 sm:mb-3 md:mb-4 overflow-x-auto"
      style={{ fontFamily: "'Fira Code', monospace" }}
    >
      {asciiLines.map((line, idx) => (
        <div key={idx} className="banner-line" style={{ opacity: 0 }}>
          {line}
        </div>
      ))}
    </pre>
  );
};

export default Banner;
